import { useState, type PropsWithChildren } from 'react';

const ThoughtBox = ({ title, children }: PropsWithChildren<{ title: string }>) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="rounded-lg border border-hairline bg-raised overflow-hidden my-2 cursor-pointer transition-colors hover:border-subtle"
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex items-center gap-2.5 px-3.5 py-2.5 text-left">
        <span className="i-ph:sparkle text-accent text-[12px] flex-shrink-0" />
        <span className="font-geist text-[11.5px] uppercase tracking-[0.12em] text-secondary font-medium">{title}</span>
        <span
          className={`i-ph:caret-down text-[12px] text-muted ml-auto transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>
      {isOpen && (
        <div
          className="px-3.5 pb-3.5 max-h-64 overflow-y-auto text-[13px] italic leading-[1.6] text-muted"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default ThoughtBox;
